module.exports = __webpack_public_path__ + "img/face-icon.e7a2c17c.svg";